// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import SignatureCanvas from 'react-signature-canvas';

import Modal from '../Modal';

import '../../../styles/settings.css';

export default class PublicSignature extends Modal {

    state = {
        mode: "sign",
        typed: "",
        signed: false,
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">
            
            <br /><br />

            <h1>Please sign below...</h1>

            <p style={{
                width: 520,
                margin: '0 auto',
                fontSize: 12,
                lineHeight: '20px',
                color: 'rgb(120,120,120)',
                clear: 'both',
                marginBottom: 40
            }}>
                By <strong>signing or typing</strong> your name, you are signing this document electronically. You agree that your electronic signature is the legal equivalent of your written signature on this document, and that you consent to be legally bound by this document's terms or conditions.
            </p>

            {this.state.mode === "sign" ? <>
                <div style={{
                    position: 'relative',
                    width: 390,
                    margin: '0 auto'
                }}>
                    <SignatureCanvas
                        ref={ref => { this.signature = ref; }}
                        velocityFilterWeight={0.9}
                        minDistance={1}
                        maxWidth={1.5}
                        penColor={"rgb(0,100,140"}
                        throttle={32}
                        canvasProps={{
                            width: 390,
                            height: 140,
                            className: "settings-signature-pad"
                        }}
                        onEnd={() => this.setState({ signed: true })}
                    />
                    {this.signature && !this.signature.isEmpty() && <div
                        className="settings-signature-clear"
                        onClick={() => {
                            if (this.signature) this.signature.clear();
                            this.setState({ signed: false, typed: "" });
                        }}
                    >
                        Clear
                    </div>}
                </div>
                <div
                    className="settings-signature-underline"
                    style={{ margin: '0 auto' }}
                >
                    Sign above this line
                </div>

            </> : <>
                <h2>Type your name</h2>
                <input
                    type="text"
                    className="public-signature-type-input"
                    value={this.state.typed}
                    onChange={(e) => this.setState({ typed: e.target.value })}
                />
            </>}

            {!this.props.data.mouseOnly && <div
                className="public-signature-mode-switch"
                onClick={() => this.setState({ mode: this.state.mode === "sign" ? "type" : "sign" })}
            >...or {this.state.mode === "sign" ? "type your name" : "draw your signature"} instead.</div>}
            
            {/* Confirm */}
            {(this.state.mode === "sign" && this.signature && this.state.signed) || (this.state.mode === "type" && this.state.typed.length > 4) ? <div style={{
                width: 200,
                margin: '0 auto',
                marginTop: 20
            }}>
                <div
                    className="button"
                    style={{ backgroundImage: "url('https://static.stax.ai/images/icons/sign.png')" }}
                    onClick={() => {
                        if (this.state.mode === "sign")
                            this.props.data.sign({
                                signature: this.signature.toDataURL(),
                                timestamp: new Date()
                            });
                        else
                            this.props.data.sign({
                                typed: this.state.typed,
                                timestamp: new Date()
                            });
                        this.props.modal();
                    }}
                >Accept & Sign</div>
            </div> : ""}
            
        </div>);
    }

};